import script from "./EditTimetableInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditTimetableInput.vue?vue&type=script&setup=true&lang=ts"

import "./EditTimetableInput.vue?vue&type=style&index=0&id=a7a04150&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7a04150"]])

export default __exports__